export default __webpack_public_path__ + "static/play_icon-81de58bb56c3ba92b6027472df12178a.svg";